import {
  NOVEL_FAILED,
  NOVEL_REQUEST,
  NOVEL_SUCCESS,
} from "app/redux/actions/SeriesProduct/Novel/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const novelReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case NOVEL_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case NOVEL_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case NOVEL_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
